<template>
    <div>
        <el-container>
            <el-header>
                <h4 class="header">Заказ №{{ order.id }}</h4>
            </el-header>
            <el-main>
                <el-card class="box-card">
                    <el-button @click="recalculateOrder">Пересчитать заказ</el-button>
                    <el-button @click="cancelOrder" type="danger" v-if="order.status === statusConfig.created.value ||
                        order.status === statusConfig.accepted.value ||
                        order.status === statusConfig.awaitingInStorage.value ||
                        order.status === statusConfig.readyToGiveaway.value">Отменить заказ</el-button>
                    <el-button v-if="order && order.need_code_to_complete == true" :disabled="sendingCode"
                        @click="refreshCode">Отправить код повторно</el-button>
                </el-card>
                <el-card class="box-card">
                    Статус заказа: {{ getStatusOrder(order.status) }}
                    <el-button v-if="order.status !== statusOrder.completed.value" style="float: right; padding: 3px 0"
                        type="text" @click="$store.commit('showOrderStatusDialog', true)">Изменить</el-button>
                </el-card>
                <el-card class="box-card">
                    <el-button v-if="order.status !== statusOrder.completed.value && order.paid !== true"
                        style="float: right; padding: 3px 0" type="text"
                        @click="$store.commit('showOrderPaymentTypeDialog', true)">Изменить</el-button>
                    <div class="text item"> Тип оплаты: {{ getPaymentTypeOrder(order.payment_type) }}</div>
                    <div class="text item"> Оплачен: {{ order.paid ? 'Да' : 'Нет' }}</div>
                </el-card>
                <el-row>
                    <el-col :span="12">
                        <el-card class="box-card" v-if="order.user_info">
                            <div slot="header" class="clearfix">
                                <span>Покупатель</span>
                                <!-- <el-button
                                style="float: right; padding: 3px 0"
                                v-if="order.status !== statusOrder.completed.value"
                                type="text"    
                                @click="$store.commit('showOrderProfileDialog',true)"                     
                                >
                                    Изменить
                                </el-button> -->
                            </div>
                            <div class="text item"> Тип: {{ order.user_info.payer_type ===
                                userProfileTyp.individual.value ? 'Физическое лицо' : 'Юридическое лицо' }}</div>
                            <div class="text item"> Имя: {{ order.user_info.full_name }}</div>
                            <div class="text item"> Телефон: {{ order.user_info.phone }}</div>
                            <div class="text item"> Почта: {{ order.user_info.email }}</div>
                            <div class="text item"> Дата регистрации: {{ getHumanDate(order.created_at) }}</div>
                            <div class="item" v-if="order.user_info.payer_type === userProfileTyp.legal.value">
                                <div class="text item"> Название компании: {{ order.user_info.company.name }}</div>
                                <div class="text item"> ИНН: {{ order.user_info.company.inn }}</div>
                                <div class="text item"> КПП: {{ order.user_info.company.kpp }}</div>
                                <div class="text item"> Юридический адрес: {{ order.user_info.company.address }}</div>
                                <!-- <div class="text item" > Использовал(а) скидку по карте? {{order.basket.card === null? 'Нет':'Да'}}</div> -->
                                <!-- <div class="text item" v-if="order.basket.card !== null" > Номер карты: {{order.basket.card.number}}</div>
                                <div class="text item" v-if="order.basket.card !== null" > Скидка по карте: {{order.basket.card.discount}} %</div> -->
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="12">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix">
                                <span>Информация о доставке</span>
                                <el-button style="float: right; padding: 3px 0" type="text"
                                    v-if="order.status !== statusOrder.completed.value"
                                    @click="$store.commit('showOrderDeliveryInfoDialog', true)">Изменить</el-button>
                            </div>
                            <div class="text item"> Тип доставки: {{ getTypeDeliveryName(order.delivery_type) }}</div>
                            <div v-if="order.delivery_info">
                                <div class="text item"
                                    v-if="order.delivery_info && order.delivery_info.address.transport_company_id">
                                    Транспортная компания:
                                    {{ getTransportCompanyValue(order.delivery_info.address.transport_company_id) }}
                                </div>
                                <div class="text item"> Дата: {{ order.delivery_info.date }}</div>
                                <div class="item" v-if="order.delivery_type !== deliveryType.pickup.value">
                                    <div class="text item">
                                        Время: {{ order.delivery_info.time }}
                                    </div>
                                    <div class="text item"
                                        v-if="order.delivery_info && order.delivery_info.address.city && order.delivery_type === deliveryType.deliveryTC.value">
                                        Населенный пункт: {{ order.delivery_info.address.city }}
                                    </div>
                                    <div class="text item"
                                        v-if="order.delivery_info && order.delivery_info.address.region_id && order.delivery_type === deliveryType.delivery.value">
                                        Населенный пункт: {{ getRegionValue(order.delivery_info.address.region_id) }}
                                    </div>
                                    <div class="text item">
                                        Адрес: {{ implodeAddress(order.delivery_info.address) }}
                                    </div>
                                    <div class="text item">
                                        Этаж: {{ order.delivery_info.address.floor }}
                                    </div>
                                    <div class="text item">
                                        До двери: {{ order.delivery_info.to_the_door ? 'Да' : 'Нет' }}
                                    </div>
                                    <div class="text item">
                                        Тип подъема:
                                        {{ order.delivery_info.to_the_door_climb === climbType.elevator.value ? 'Лифт' :
                                            'Лестница' }}
                                    </div>
                                </div>

                            </div>

                        </el-card>
                    </el-col>
                </el-row>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>Позиции</span>
                        <el-button style="float: right; padding: 3px 0"
                            v-if="order.status !== statusOrder.completed.value && !order.paid"
                            @click="$store.commit('showOrderSkusDialog', true)" type="text">Изменить</el-button>
                    </div>
                    <el-table :data="order.items" style="width: 100%" :summary-method="getSummaries" show-summary
                        empty-text="Нет товаров">
                        <el-table-column prop="title" label="Название" width="500px" />
                        <el-table-column prop="price" label="Цена за шт. (без скидки)" />
                        <el-table-column label="Скидка">
                            <template slot-scope="scope">
                                {{ order.items[scope.$index].discount }}
                                ({{ getDiscountPercent(order.items[scope.$index].price,
                                    order.items[scope.$index].discount) }}) %
                            </template>

                        </el-table-column>
                        <el-table-column prop="price" label="Цена за шт. (со скидкой)">
                            <template slot-scope="scope">
                                {{ getPriceDiscount(order.items[scope.$index].price,
                                    order.items[scope.$index].discount) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="amount" label="Кол-во" />
                        <el-table-column label="Стоимость" prop="cost">
                            <template slot-scope="scope">
                                {{ getCost(
                                    order.items[scope.$index].price,
                                    order.items[scope.$index].amount,
                                    order.items[scope.$index].discount) }}
                                <!-- ('+order.items[scope.$index].discount_percent+' %)' -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card" v-if="order.comment && order.comment !== 'null'">
                    <div slot="header" class="clearfix">
                        <span>Комментарий к заказу</span>
                    </div>
                    <span>
                        {{ order.comment }}
                    </span>
                </el-card>

                <el-row>
                    <el-card class="box-card">
                        <div class="text item">Вложения: </div>
                        <div class="demo-image__preview" v-if="order.receipts && order.receipts.length > 0">
                            <el-image style="width: 100px; height: 100px" :src="receipts[0]"
                                :preview-src-list="receipts" :initial-index="4" fit="cover" />
                        </div>
                    </el-card>
                </el-row>
            </el-main>
        </el-container>

        <status :order-id="order.id" :status1="order.status" :payment-type="order.payment_type"
            :delivery-type="order.delivery_type" :need-code="order.need_code_to_complete"
            @updateParent="onUpdateSalary">
        </status>
        <payment-type v-bind:order-id="order.id" :payment-type1="order.payment_type"
            @updateParent="onUpdateSalary"></payment-type>
        <!-- <profile
        v-if="order.user_info"
        v-bind:order-id="order.id"
        :profile1="order.user_info"
        @updateParent="onUpdateSalary"></profile> -->
        <delivery-info v-bind:order-id="order.id" :regions="regions" :transportCompanies="transportCompanies"
            :pickupDate="order.pickup_date" :delivery-info1="order.delivery_info" :delivery-type1="order.delivery_type"
            @updateParent="onUpdateSalary"></delivery-info>
        <product-sku-add v-if="$store.getters.showOrderSkusDialog" :order-id="order.id"
            :price-type-id="order.price_type.id" :skus-selected1="getSkuIdAndQuantity(order.items)"
            @updateParent="onUpdateSalary" />
    </div>
</template>

<script>
import axios from "axios";
import Status from "@/components/Orders/dialogs/Status";
import PaymentType from "@/components/Orders/dialogs/PaymentType";
// import Profile from "@/components/Orders/dialogs/Profile";
import DeliveryInfo from "@/components/Orders/dialogs/DeliveryInfo";
import ProductSkuAdd from "@/components/Orders/dialogs/ProductSkuAdd";
import statusOrder from '../../composable/type/status-order.type';
import paymentTypeOrder from '../../composable/type/payment-type-order.type';
import userProfileTyp from '../../composable/type/user-profile.type';
import deliveryType from '../../composable/type/delivery.type';
import climbType from '../../composable/type/climb.type';
import statusConfig from '../../composable/type/status-order.type';


export default {
    components: { Status, PaymentType, DeliveryInfo, ProductSkuAdd },
    data: () => {
        return {
            order: {},
            values: [],
            regions: [],
            transportCompanies: [],
            sendingCode: false,
            statusOrder,
            paymentTypeOrder,
            userProfileTyp,
            deliveryType,
            climbType,
            statusConfig,
        }
    },
    computed: {
        receipts() {
            if (this.order?.receipts?.length > 0) {
                return this.order.receipts.map((e) => e.path)
            }
            return []
        }
    },
    mounted() {
        this.getOrder();
        this.getRegions();
        this.getTransportCompanies();
    },
    methods: {
        onUpdateSalary() {
            this.getOrder();
        },
        getCost(price, quantity, discount) {
            const p = Number.parseFloat(this.getPriceDiscount(price, discount))
            const result = p * quantity
            return result.toFixed(2)
        },
        getRegions() {
            axios.get('delivery-region/').then((response) => {
                this.regions = response.data.data;
            }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }
            });
        },
        getTransportCompanies() {
            axios.get('transport-company').then((response) => {
                this.transportCompanies = response.data.data;
            })
                .catch()
        },
        getPriceDiscount(price, discount) {
            const result = price - discount
            return result.toFixed(2)
        },
        getDiscountPercent(price, discount) {
            let result = 0;
            result = (discount * 100) / price
            return Math.round(result)
        },
        getOrder() {
            axios.get('/order/' + this.$route.params.id).then((response) => {
                this.order = response.data;
            }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }
            });
        },
        getSkuIdAndQuantity(items) {
            let array = [];
            items.forEach(function (item) {
                array.push({ quantity: item.amount, id: item.id })
            });
            return items;
        },
        getStatusOrder(status) {
            for (const value of Object.values(this.statusOrder)) {
                if (value.value === status) {
                    return value?.title || ''
                }
            }
        },
        getPaymentTypeOrder(type) {
            for (const value of Object.values(this.paymentTypeOrder)) {
                if (value.value === type) {
                    return value?.title || ''
                }
            }
        },
        getHumanDate(date) {
            const d = new Date(date)
            if (d) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return d.toLocaleDateString('ru-RU', options)
            }

            return ''
        },
        recalculateOrder() {
            const id = this.$route.params.id
            axios.post('/order/' + id + '/recalculate', { order: id })
                .then((response) => this.order = response.data)
                .then(() => {
                    this.$notify.success('Заказ пересчитан')
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        this.$router.push('/login');
                    } else if (err.response?.data?.message) {
                        this.$notify.error(err.response?.data?.message)
                    }
                });
        },

        cancelOrder() {
            axios.post('/order/' + this.$route.params.id + '/status', { status: this.statusConfig.canceled.value }).then((response) => {
                if (response.data.success) {
                    this.$notify.success({
                        message: 'Заказ отменен'
                    })
                    this.getOrder();
                } else {
                    this.$notify.error({
                        message: 'Не удалось отменить заказ'
                    })
                }

            }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                }
            });
        },
        implodeAddress(address) {
            return 'ул. ' + address.street + ' д. ' + address.house + ' кв. ' + address.apartment;
        },
        getSummaries(param) {
            const { columns } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Итого:';
                }

                else if (index === columns.length - 1) {
                    sums[index] = this.order?.total?.final || 0;
                }

            });

            return sums;
        },
        getTransportCompanyValue(id) {
            if (!id) {
                return '-'
            }
            return this.transportCompanies.find((e) => e.id === id)?.name ?? '-'
        },
        getRegionValue(id) {
            if (!id) {
                return '-'
            }
            return this.regions.find((e) => e.id === id)?.name ?? '-'
        },
        getTypeDeliveryName(val) {
            if (!val) {
                return '-'
            }
            for (const value of Object.values(this.deliveryType)) {
                if (value.value === val) {
                    return value.title
                }
            }
            return '-'
        },
        refreshCode() {
            if (this.sendingCode) {
                return;
            }
            if (!this.order?.id) {
                this.$notify.error({
                    message: 'Не удалось определить заказа'
                })
                return;
            }
            this.sendingCode = true;
            axios.post('/order/' + this.order.id + '/send-code').then((response) => {
                if (response?.data?.success) {
                    this.$notify.success({
                        message: 'Код отправлен'
                    })
                } else {
                    this.$notify.error({
                        message: 'Не удалось отправить код'
                    })
                }

            }
            ).catch((errors) => {
                if (errors.response.status === 401) {
                    this.$router.push('/login');
                } else if (errors.response.status === 422 && errors.response?.data?.message) {
                    this.$notify.error({
                        message: 'Не удалось отправить код'
                    })
                }
            })
                .finally(() => (this.sendingCode = false));
        },
    }
}
</script>

<style scoped>
.box-card {
    margin: 10px;
}
</style>